/**
 * PoliceDepartmentTableHeader - Streamlined header for police departments table
 */

import { PlusIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/ui/catalyst/button';

interface PoliceDepartmentTableHeaderProps {
  totalCount: number;
  onCreateClick: () => void;
}

export const PoliceDepartmentTableHeader = ({
  totalCount,
  onCreateClick,
}: PoliceDepartmentTableHeaderProps) => {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
      <div>
        <h1 className="text-lg font-semibold text-gray-900">
          Police Departments
        </h1>
        <p className="mt-0.5 text-sm text-gray-500">
          {totalCount.toLocaleString()}{' '}
          {totalCount === 1 ? 'department' : 'departments'}
        </p>
      </div>
      <Button onClick={onCreateClick}>
        <PlusIcon />
        New Department
      </Button>
    </div>
  );
};
